module.exports = dataLayer;


//////////////////
// WEBPACK FOOTER
// external "dataLayer"
// module id = 190
// module chunks = 0